// extracted by mini-css-extract-plugin
export default {"tupacGrid":"nl-z","tupacHeader":"ol-z","tupacHeader2":"pl-z","tupacMenu":"ql-z","tupacMenu2":"rl-z","tupacMain":"sl-z","tupacMain2":"tl-z"};